import { colors } from '@material-ui/core';

const white = '#FFFFFF';

export default {
  primary: {
    contrastText: white,
    dark: '#00417D',
    main: '#329BFF',
    light: '#329BFF'
    // dark: colors.indigo[900],
    // main: colors.indigo[500],
    // light: colors.indigo[100],
  },
  secondary: {
    contrastText: white,
    dark: '#EE7824',
    main: '#EE7824',
    light: '#EE7824',
    // dark: colors.blue[900],
    // main: colors.blue.A700,
    // light: colors.blue.A400,
  },
  tertiary: {
    contrastText: white,
    dark: '#025184',
    main: '#025184',
    light: '#025184',
    // dark: colors.orange[900],
    // main: colors.orange[500],
    // light: colors.amber[500],
  },
  error: {
    contrastText: white,
    dark: colors.red[900],
    main: colors.red[600],
    light: colors.red[400],
  },
  text: {
    primary: colors.blueGrey[600],
    secondary: colors.blueGrey[600],
    link: colors.blue[600],
  },
  link: colors.blue[800],
  icon: colors.blueGrey[600],
  background: {
    default: '#F4F6F8',
    paper: white,
  },
  divider: colors.grey[200],
};
